import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { axiosWrapper } from '@/services/axiosWrapper';
import _log from '@/helpers/log';
import 'whatwg-fetch';
import DOMPurify from 'dompurify';
// import { VITE_HYSIZE_BACK_END_BASE_URL } from '@/helpers/environment';
import axios from 'axios';
axios.defaults.adapter = 'xhr';

@Module({
  namespaced: true
})
class Cgu extends VuexModule {
  private cguAcceptance: boolean = true;
  private cgu: any = null;
  private cguHtml: any = null;
  private cguAreLoaded: boolean = false;
  private cguAll: any = {
    fr: null,
    en: null
  };

  @Action
  public getLatestCguFromApi() {
    this.context.commit('setCGUAreLoaded', false);
    axiosWrapper
      .getFromApi('/cgu/last/mustAccept')
      .then((res: any) => {
        this.context.commit('setCGUAcceptance', false);
        this.context.commit('setCGU', res.data);
        this.context.dispatch('getCguPage', res.data.content.en);
      })
      .catch((err) => {
        if (err && err.response && err.response.status === 404) {
          this.context.commit('setCGUAreLoaded', true);
          this.context.commit('setCGUAcceptance', true);
        }
      });
  }
  @Action
  public getCguPage(url: string) {
    // DOMPurify used to sanitize data
    axios
      .get<string>(`${process.env.VITE_HYSIZE_BACK_END_BASE_URL}${url}`)
      .then((response) => {
        this.context.commit('setCGUAreLoaded', true);
        const corsHTML = DOMPurify.sanitize(response.data);
        const htmlDoc = new DOMParser().parseFromString(corsHTML, 'text/html');
        this.context.commit('setCGUHtml', htmlDoc.body.innerHTML);
      });
  }
  @Action
  public getLastCguPage(payload: any) {
    // TODO : wrap this get method in the axioswrapper
    if (!this.context.getters.getCGUAll[payload.locale]) {
      axios
        .get<string>(
          `${process.env.VITE_HYSIZE_BACK_END_BASE_URL}${payload.path}`
        )
        .then((response) => {
          const corsHTML = DOMPurify.sanitize(response.data);
          const htmlDoc = new DOMParser().parseFromString(
            corsHTML,
            'text/html'
          );
          this.context.commit('setCGUHtml', htmlDoc.body.innerHTML);
          this.context.commit('setCGUAll', {
            data: htmlDoc.body.innerHTML,
            locale: payload.locale
          });
        });
    }
  }
  @Action
  public postAcceptCgu() {
    axiosWrapper
      .postToApi(`/cgu/last/accept`)
      .then((res: any) => {
        this.context.commit('setCGUAcceptance', true);
      })
      .catch((err) => {
        _log.logError(err);
      });
  }
  @Mutation
  setCGUAreLoaded(bool: boolean) {
    this.cguAreLoaded = bool;
  }

  @Mutation
  private setCGU(payload: any) {
    this.cgu = payload;
  }

  @Mutation
  private setCGUAll(payload: any) {
    this.cguAll[payload.locale] = payload.data;
  }

  @Mutation
  private setCGUHtml(payload: any) {
    this.cguHtml = payload;
  }

  @Mutation
  private setCGUAcceptance(payload: any) {
    this.cguAcceptance = payload;
  }

  get getCGUAreLoaded(): boolean {
    return this.cguAreLoaded;
  }

  get getCGU(): any {
    return this.cgu;
  }
  get getCGUAll(): any {
    return this.cguAll;
  }
  get getCGUHtml(): any {
    return this.cguHtml;
  }
  get getCGUAcceptance(): boolean {
    return this.cguAcceptance;
  }
}

export default Cgu;
